const PlotModel = {
    plot_read_model : {
        name: "",
        crop_id: "undefined",
        terrain_id: "",
        id: "",
        modules: [],
        params: {
            plot_area: 0,
            total_crop_area: 0,
            sigpac_code: "None",
            irrigation: {
                irrigation_system: "located",
                dropper_type: "",
                dropper_flow: "",
                droppers_per_tree: "",
                droppers_distance: "",
                application_efficiency: 0.9
            },
            crop: {
                crop_type: "agrostis",
                plantation_age: "",
                variety: "",
                variety_type: "",
                tree_distance: "",
                row_distance: "",
                crown_diameter: "",
                cup_height: "",
                visible_root_depth: "",
                covered_presence: "false",
                crop_coefficient: 1.0,
                crop_development_coefficient: 1.0
            },
            soil: {
                uniformity_coefficient: "",
                organic_material: "",
                clay_percentage: "",
                lime_percentage: "",
                sand_percentage: "",
                soil_texture: "",
                texture_type: "noTextureType",
            },
            temperature: {
                min: 0,
                max: 0,
                extraterrestrial_solar_radiation: [],
                KT_coefficient: 0.17,
            }
        }
    }
};

export default PlotModel;